import countries from 'constants/countries';

const visualisationUrls = {
  traditional: 'https://view.qbiq.ai/viewer/index.html#/896c79',
  moderate: 'https://view.qbiq.ai/viewer/index.html#/2deed3',
  progressive: 'https://view.qbiq.ai/viewer/index.html#/160292',
};
const traditionalImageUrls = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb1',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb2',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb3',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb4',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb5',
];
const traditionalImageUrlsDE = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb2',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb1',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb3',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Traditional/Style-Traditional-Thumb4',
];
const traditionalImageUrlsUK = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale,f_auto,q_80,w_1200/v1686749845/Cellular_1_jhrph3.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686750329/Cellular_2_bowyb4.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686750428/Cellular_3_iyzxr7.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686750711/Cellular_4_vy3cit.jpg',
];
const traditional = {
  id: 1,
  name: 'workplaceStyles.traditional.name',
  displayOrder: 1,
  description: 'workplaceStyles.traditional.description',
  visualisationUrl: visualisationUrls.traditional,
  imageUrls: {
    [countries.US]: traditionalImageUrls,
    [countries.UK]: traditionalImageUrlsUK,
    [countries.FR]: traditionalImageUrls,
    [countries.EU]: traditionalImageUrls,
    [countries.DE]: traditionalImageUrlsDE,
  },
  circulationMultiplier: {
    [countries.US]: 45,
    [countries.UK]: 50,
    [countries.FR]: 35,
    [countries.EU]: 5,
    [countries.DE]: 40,
  },
  buildingGrossUpFactor: {
    [countries.US]: 18,
    [countries.UK]: 0,
    [countries.FR]: 12,
    [countries.EU]: 15,
    [countries.DE]: 18,
  },
  netProgramSqFootage: 0,
  usableSquareFeet: 0,
  rentableSquareFeet: 0,
  rentableSquareFeetPerHead: 0,
  totalHeadcount: 0,
};

const moderateImageUrls = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb1',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb2',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb3',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb4',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb5',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb6',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb7',
];
const moderateImageUrlsDE = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb3',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb1',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb2',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/Moderate/Style-Moderate-Thumb4',
];
const moderateImageUrlsUK = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686750791/Hybrid_cellular_1_v3hmzq.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686750794/Hybrid_cellular_2_aifyj7.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/f_auto%2cq_80/v1686750792/Hybrid_cellular_3_msfgdd.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686750796/Hybrid_cellular_4_wuw34y.jpg',
];
const moderate = {
  id: 2,
  name: 'workplaceStyles.moderate.name',
  displayOrder: 2,
  description: 'workplaceStyles.moderate.description',
  visualisationUrl: visualisationUrls.moderate,
  imageUrls: {
    [countries.US]: moderateImageUrls,
    [countries.UK]: moderateImageUrlsUK,
    [countries.FR]: moderateImageUrls,
    [countries.EU]: moderateImageUrls,
    [countries.DE]: moderateImageUrlsDE,
  },
  circulationMultiplier: {
    [countries.US]: 54,
    [countries.UK]: 40,
    [countries.FR]: 40,
    [countries.EU]: 5,
    [countries.DE]: 40,
  },
  buildingGrossUpFactor: {
    [countries.US]: 18,
    [countries.UK]: 0,
    [countries.FR]: 12,
    [countries.EU]: 15,
    [countries.DE]: 18,
  },
  netProgramSqFootage: 0,
  usableSquareFeet: 0,
  rentableSquareFeet: 0,
  rentableSquareFeetPerHead: 0,
  totalHeadcount: 0,
};

const progressiveImageUrls = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb1',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb2',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb3',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb4',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb5',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb6',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb7',
];
const progressiveImageUrlsDE = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb2',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb1',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb3',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/tenantassessment/QA/workplace-styles/progressive/Style-progressive-Thumb4',
];
const progressiveImageUrlsUK = [
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686751074/Open_Plan_1_ruzbps.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686751048/Open_Plan_2_eidjub.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686751050/Open_Plan_3_sni1ux.jpg',
  'https://res.cloudinary.com/jll-am-tenantrep/image/upload/c_scale%2cf_auto%2cq_80%2cw_1200/v1686751052/Open_Plan_4_w0n8dg.jpg',
];
const progressive = {
  id: 3,
  name: 'workplaceStyles.progressive.name',
  displayOrder: 3,
  description: 'workplaceStyles.progressive.description',
  visualisationUrl: visualisationUrls.progressive,
  imageUrls: {
    [countries.US]: progressiveImageUrls,
    [countries.UK]: progressiveImageUrlsUK,
    [countries.FR]: progressiveImageUrls,
    [countries.EU]: progressiveImageUrls,
    [countries.DE]: progressiveImageUrlsDE,
  },
  circulationMultiplier: {
    [countries.US]: 60,
    [countries.UK]: 40,
    [countries.EU]: 5,
    [countries.FR]: 40,
    [countries.DE]: 40,
  },
  buildingGrossUpFactor: {
    [countries.US]: 18,
    [countries.UK]: 0,
    [countries.FR]: 12,
    [countries.EU]: 15,
    [countries.DE]: 18,
  },
  netProgramSqFootage: 0,
  usableSquareFeet: 0,
  rentableSquareFeet: 0,
  rentableSquareFeetPerHead: 0,
  totalHeadcount: 0,
};

export const workplaceStyles = {
  traditional,
  moderate,
  progressive,
};

export const getWorkplaceStyleById = (id, country) => {
  const workplaceStyle = Object.values(workplaceStyles).find((wpStyle) => wpStyle.id === id);

  // TODO logger
  if (!workplaceStyle) throw Error('getWorkplaceStyleById called with non available id: ' + id);

  return {
    ...workplaceStyle,
    imageUrls: workplaceStyle.imageUrls[country],
    circulationMultiplier: workplaceStyle.circulationMultiplier[country],
    buildingGrossUpFactor: workplaceStyle.buildingGrossUpFactor[country],
  };
};

export const getWorkplaceStyleName = (number) => {
  switch (number) {
    case 1:
      return workplaceStyles.traditional.name;
    case 2:
      return workplaceStyles.moderate.name;
    case 3:
      return workplaceStyles.progressive.name;
    default:
      return '';
  }
};
